import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import ShowChartIcon from '@material-ui/icons/ShowChart';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '226px',
    padding: '24px 16px',
  },
  iconWrapper: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    background: '#ffffff08',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '14px',
  },
  icon: {
    fontSize: '26px',
    color: '#ffffff66',
  },
  text: {
    color: '#ffffff99',
    fontSize: '13px',
    textAlign: 'center',
    lineHeight: 1.6,
  },
});

export default function NoDataComponent() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.iconWrapper}>
        <ShowChartIcon className={classes.icon} />
      </div>
      <Typography className={classes.text}>
        Sem dados para exibir.
        <br />
        Adicione trades para visualizar.
      </Typography>
    </div>
  );
}
